import { render } from "./ProductKeysOverview.vue?vue&type=template&id=3584ff66&ts=true"
import script from "./ProductKeysOverview.vue?vue&type=script&lang=ts"
export * from "./ProductKeysOverview.vue?vue&type=script&lang=ts"

import "./ProductKeysOverview.vue?vue&type=style&index=0&id=3584ff66&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__